import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  tiendaObtener,
  tiendaActualizarFormularioContacto,
} from '../../store/actions';
import { Grid, withStyles } from '@material-ui/core';
import { ButtonUI, AlertUI, ModuleTitleUI } from '../common';
import { WrapperLayout } from '../../layouts/WrapperLayout';

class FormularioContacto_ extends Component {
  state = {
    loading: {
      formulario_contacto: true,
      error: false,
    },
    forms: {
      formulario_contacto: false,
    },
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    this.props.tiendaObtener((err, resp) => {
      this.setState({
        loading: {
          ...this.state.loading,
          formulario_contacto: false,
          error: err ? true : false,
        },
      });
    });
  }

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      forms: {
        ...this.state.forms,
        formulario_contacto: true,
      },
    });

    this.props.tiendaActualizarFormularioContacto(
      {
        t_formulario_contacto: this.props.tienda.t_formulario_contacto ? 0 : 1,
      },
      (err, resp) => {
        this.setState({
          forms: {
            ...this.state.forms,
            formulario_contacto: false,
          },
          alert: {
            ...this.state.alert,
            open: true,
            message: resp.message,
            type: err ? 'error' : 'success',
          },
        });
      }
    );
  };

  render() {
    return (
      <WrapperLayout
        loading={this.state.loading.formulario_contacto}
        error={this.state.loading.error}
      >
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <Grid container spacing={24}>
          <Grid item xs={12}>
            <ModuleTitleUI
              title="Formulario de contacto"
              subtitles={[
                'En ésta sección podes activar un formulario de contacto que aparecerá en el menú principal de tu tienda online.',
                'Las consultas que envíen tus clientes desde el formulario te llegarán al email configurado en la sección de "Mi tienda" > "General".',
              ]}
              button={
                <ButtonUI
                  type="callf"
                  label={
                    this.props.tienda.t_formulario_contacto
                      ? 'Desactivar'
                      : 'Activar'
                  }
                  fullWidth={false}
                  onClickFunc={this.handleSubmit}
                  isLoading={this.state.forms.formulario_contacto}
                />
              }
            />
          </Grid>
        </Grid>
      </WrapperLayout>
    );
  }
}

const styles = (theme) => ({
  card: theme.card.card,
  card_header: theme.card.card_header,
  card_header_title: theme.card.card_header_title,
  card_content: theme.card.card_content,
  card_actions: theme.card.card_actions_public,
  card_subheader: theme.card.card_subheader,
  card_subheader_icon: theme.card.card_subheader_icon,
});

const mapStateToProps = (state) => {
  return {
    tienda: state.tienda,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    tiendaObtener: (callback) => dispatch(tiendaObtener(callback)),
    tiendaActualizarFormularioContacto: (data, callback) =>
      dispatch(tiendaActualizarFormularioContacto(data, callback)),
  };
};

export const FormularioContacto = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(FormularioContacto_)
);
